// extracted by mini-css-extract-plugin
export var bottom = "index-module--bottom--1d409";
export var bottomContent = "index-module--bottomContent--62caa";
export var content = "index-module--content--fe0f9";
export var dataArea = "index-module--dataArea--cb7ea";
export var label = "index-module--label--406e4";
export var leftContent = "index-module--leftContent--01490";
export var overlaywrap = "index-module--overlaywrap--cf8ff";
export var popoverImg = "index-module--popoverImg--01cc5";
export var popoverImg1 = "index-module--popoverImg1--0ccdd";
export var right = "index-module--right--a4e01";
export var rightContent = "index-module--rightContent--90757";
export var tableTooltips = "index-module--tableTooltips--4e78a";
export var tipsLine = "index-module--tipsLine--baa20";
export var tipsTitle = "index-module--tipsTitle--77d66";
export var tipsWrap = "index-module--tipsWrap--e496e";
export var title = "index-module--title--960cd";
export var topSection = "index-module--topSection--26f4b";